import camelCase from "lodash/camelCase";

// All features that can be flipped on/off for a user
// This list serves several purposes:
// 1. Store feature values as constants for easy reference
// 2. Provide a list of all active/used features in the codebase

// 3. Make cleanup easy by throwing TS errors anywhere a feature is used that is no longer active
export enum Feature {
  PAYMENTS_TOOLS = "payments_tools",
  DEFAULT_RETURN_ADDRESS = "default_return_address",
  SORT_MARKETING_COLLECTIONS_BY_LATEST_ACTIVITY = "sort_marketing_collections_by_latest_activity",
  INTERNAL_DELETE_VIOLATIONS = "internal_delete_violations",
  EXPIRED_LISTINGS = "expired_listings",
}

export const camelizedFeature = (feature: Feature) => camelCase(feature);
